var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"list",staticClass:"scroll-list-container infinite-list-container",on:{"&scroll":function($event){return _vm.scrollEvent($event)}}},[_c('div',{ref:"phantom",staticClass:"infinite-list-phantom",style:(_vm.getHeight)}),_c('div',{ref:"content",staticClass:"infinite-list",class:{
      'gantt-outbox-border': (!_vm.$store.state.viewSchem.noGanttOutBoxBorder),
    }},_vm._l((_vm.visibleData),function(item){return _c('div',{key:item.id,ref:"items",refInFor:true,staticClass:"infinite-list-item",class:{
        'list-item-border-bottom': item.borderBottom == true,
      },style:({
        'height': ((item.rowCount?item.rowCount:1) * _vm.estimatedItemSize  + 'px'),
        'color': item.color,
      }),attrs:{"data-name":item.name,"data-id":item.id}},[_vm._t("default",null,{"item":item})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }